module.exports = __webpack_public_path__ + "img/a2.4de2bbaf.jpg";